<template>
    <div v-if="!hide" class="form-network form-network-google" >

        <details open>
            <summary>{{ $t('dash.post-creator.form.link-preview') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail form-link">
                <div class="list-thubmmail">
                  
                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(formDataNetwork.snippet.link == url)" 
                            :isDisable="(formDataNetwork.snippet.link == url)"
                            :add="selectUrl" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url"
                            :imageUrlDefault="!inputModel.switchCustomSnippet || inputModel.titleSnippet || inputModel.descriptionSnippet ? undefined : inputModel.urlImageSnippet" 
                            :titleDefault="inputModel.switchCustomSnippet ? inputModel.titleSnippet : undefined" 
                            :descriptionDefault="inputModel.switchCustomSnippet ? inputModel.descriptionSnippet : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
              
            </div>
        </details>
   </div>
</template>

<script>
   import { EventBus } from '@/event-bus';
   import store from '@/store/index.js';
   import ComponentSwitch from '@/components/dash/utils/switch.vue'
   import SelectComponent from '@/components/dash/utils/select.vue'
   import SnippetNetwork from './../SnippetNetwork.vue'
   import minxinBot from '@/components/mixins/Bots.vue'
   import minxinPost from '@/components/mixins/Posts.vue'
   import Checkbox from '@/components/dash/utils/checkbox.vue'
   export default {

       components: {
           ComponentSwitch,
           SelectComponent,
           SnippetNetwork,
           Checkbox
       },
       mixins: [minxinBot,minxinPost],

       props: {
           hide : {
               type: Boolean,
               default: false
           },
           formData: {
               type: Object,
               default: () => ({})
           },

           formDataNetwork: {
               type: Object,
               default: () => ({})
           },
       },

       data() {
           return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined
           }
       },

       
       mounted() {
            if (this.formData.formDataNetwork.google) this.formDataNetwork = this.formData.formDataNetwork.google
       },

       methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            selectTypeContent(typeContent = '') {
                this.formDataNetwork.typeContent = this.formDataNetwork.typeContent == typeContent ? '' : typeContent
                this.$emit('setFormDataNetwork', 'google', this.formDataNetwork)
            },

            detectTypeContent() {
                if(this.formData.files.length) { 
                    if(this.formDataNetwork.typeContent !== 'survey' 
                        && (this.formDataNetwork.typeContent !== 'link' || !this.formDataNetwork.snippet.link)
                        && !this.formData.files.find(file => file.type2 == this.formDataNetwork.typeContent)) {

                        let file = this.formData.files.find(file => ['video','image','pdf'].includes(file.type2))
                        if (file) {
                            this.formDataNetwork.typeContent = file.type2
                            this.$emit('setFormDataNetwork', 'google', this.formDataNetwork)
                        }
                    }
                }
            },

    
            selectUrl(url) {
                if (!this.formDataNetwork.snippet) this.formDataNetwork.snippet = {}
                this.formDataNetwork.snippet.link = this.formDataNetwork.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'google', this.formDataNetwork)
            },


            verifUrlSelected() {
                if (this.formData.urlsTextContentHistory.length) {
                    let linkSelect = this.formDataNetwork && this.formDataNetwork.snippet && this.formDataNetwork.snippet.link ? this.formDataNetwork.snippet.link : null
                    if ((linkSelect && !this.formData.urlsTextContentHistory.includes(linkSelect)) || !linkSelect) {
                        this.selectUrl(this.formData.urlsTextContentHistory[0])
                    }
                }else{
                    this.selectUrl('')
                }
            },
       },

       computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
       },

       watch: {
            ['formData.formDataNetwork.google']() {
                if (this.formData.formDataNetwork.google) this.formDataNetwork = this.formData.formDataNetwork.google
            },
            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },
            'formData.files'(newValue) {
                this.detectTypeContent()
            }
       },


       beforeDestroy () {
         
       }
       
   }
</script>